__turbopack_export_value__({
  "body-logo-18": "MainSlide-module-scss-module__CHngsW__body-logo-18",
  "body-text-12": "MainSlide-module-scss-module__CHngsW__body-text-12",
  "body-text-14": "MainSlide-module-scss-module__CHngsW__body-text-14",
  "body-text-16": "MainSlide-module-scss-module__CHngsW__body-text-16",
  "body-text-18": "MainSlide-module-scss-module__CHngsW__body-text-18",
  "body-text-20": "MainSlide-module-scss-module__CHngsW__body-text-20",
  "body-text-24": "MainSlide-module-scss-module__CHngsW__body-text-24",
  "body-text-24-2": "MainSlide-module-scss-module__CHngsW__body-text-24-2",
  "body-text-heading-2": "MainSlide-module-scss-module__CHngsW__body-text-heading-2",
  "body-text-heading-3": "MainSlide-module-scss-module__CHngsW__body-text-heading-3",
  "body-text-medium-14": "MainSlide-module-scss-module__CHngsW__body-text-medium-14",
  "body-text-medium-16": "MainSlide-module-scss-module__CHngsW__body-text-medium-16",
  "body-text-medium-18": "MainSlide-module-scss-module__CHngsW__body-text-medium-18",
  "body-text-medium2-18": "MainSlide-module-scss-module__CHngsW__body-text-medium2-18",
  "body-text2-14": "MainSlide-module-scss-module__CHngsW__body-text2-14",
  "body-text2-16": "MainSlide-module-scss-module__CHngsW__body-text2-16",
  "button-primary-text": "MainSlide-module-scss-module__CHngsW__button-primary-text",
  "button-text": "MainSlide-module-scss-module__CHngsW__button-text",
  "button2-text": "MainSlide-module-scss-module__CHngsW__button2-text",
  "card-shadow": "MainSlide-module-scss-module__CHngsW__card-shadow",
  "effect-menu": "MainSlide-module-scss-module__CHngsW__effect-menu",
  "header-1": "MainSlide-module-scss-module__CHngsW__header-1",
  "main-container": "MainSlide-module-scss-module__CHngsW__main-container",
  "main-footer-container": "MainSlide-module-scss-module__CHngsW__main-footer-container",
  "main-header-container": "MainSlide-module-scss-module__CHngsW__main-header-container",
  "slide": "MainSlide-module-scss-module__CHngsW__slide",
  "slide__container": "MainSlide-module-scss-module__CHngsW__slide__container",
  "slide__empty": "MainSlide-module-scss-module__CHngsW__slide__empty",
  "slide__image": "MainSlide-module-scss-module__CHngsW__slide__image",
  "slide__inner": "MainSlide-module-scss-module__CHngsW__slide__inner",
  "slide__link": "MainSlide-module-scss-module__CHngsW__slide__link",
  "slide__subtitle": "MainSlide-module-scss-module__CHngsW__slide__subtitle",
  "slide__title": "MainSlide-module-scss-module__CHngsW__slide__title",
  "txt-12-bold": "MainSlide-module-scss-module__CHngsW__txt-12-bold",
  "txt-14-bold": "MainSlide-module-scss-module__CHngsW__txt-14-bold",
  "txt-14-bold-caps": "MainSlide-module-scss-module__CHngsW__txt-14-bold-caps",
  "txt-14-med": "MainSlide-module-scss-module__CHngsW__txt-14-med",
  "txt-16-bold": "MainSlide-module-scss-module__CHngsW__txt-16-bold",
  "txt-16-med": "MainSlide-module-scss-module__CHngsW__txt-16-med",
  "txt-18-bold": "MainSlide-module-scss-module__CHngsW__txt-18-bold",
  "txt-18-medium": "MainSlide-module-scss-module__CHngsW__txt-18-medium",
  "txt-18-medium-24": "MainSlide-module-scss-module__CHngsW__txt-18-medium-24",
  "txt-24-semi": "MainSlide-module-scss-module__CHngsW__txt-24-semi",
});
